import StoryblokClient, { ISbRichtext } from "storyblok-js-client"

export default function calculateReadtimeFromString(content: ISbRichtext): number {
  try {
    const articleContent = new StoryblokClient({}).richTextResolver.render(
      content
    )
    return Math.max(1, Math.ceil(articleContent.split(" ").length / 200))
  } catch (error) {
    return 0
  }
}
